(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lead-magnet-spec-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    document.querySelectorAll('[data-spec-guide-form]').forEach(function (form) {
      if (form.__specGuideBound) return;
      form.__specGuideBound = true;

      var companyId = form.dataset.companyId;
      var listId = form.dataset.listId;
      var errorEl = form.querySelector('.spec-guide-cta__error');
      var submitBtn = form.querySelector('.spec-guide-cta__submit');
      var submitLabel = form.querySelector('.spec-guide-cta__submit-label');
      var originalLabel = submitLabel ? submitLabel.textContent : '';
      var contentEl = form.closest('.spec-guide-cta__content');
      var successEl = contentEl ? contentEl.querySelector('.spec-guide-cta__success') : null;

      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }

      function clearError() {
        if (!errorEl) return;
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        clearError();

        var emailInput = form.querySelector('input[type="email"]');
        var email = (emailInput.value || '').trim();

        if (!isValidEmail(email)) {
          showError('Please enter a valid email address.');
          emailInput.focus();
          return;
        }

        var selected = form.querySelector('input[type="radio"]:checked');
        if (!selected) {
          showError("Please select what you're buying for.");
          return;
        }

        if (!companyId || !listId) {
          showError("This form isn't connected yet — please try again later.");
          return;
        }

        submitBtn.disabled = true;
        if (submitLabel) submitLabel.textContent = 'Submitting…';

        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
            'revision': '2026-07-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      properties: { 'Buying For': selected.value }
                    }
                  }
                },
                custom_source: 'Dumbbell Spec Guide Section'
              },
              relationships: {
                list: { data: { type: 'list', id: listId } }
              }
            }
          })
        })
          .then(function (resp) {
            if (resp.ok || resp.status === 202) {
              form.hidden = true;
              if (successEl) successEl.hidden = false;
              return;
            }
            return resp.text().then(function (text) {
              throw new Error('Klaviyo error ' + resp.status + ': ' + text);
            });
          })
          .catch(function (err) {
            if (window.console && console.error) console.error('[spec-guide-cta] submission failed', err);
            showError('Something went wrong — please try again in a moment.');
            submitBtn.disabled = false;
            if (submitLabel) submitLabel.textContent = originalLabel;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
